var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.authUser.sites),function(site){return _c('BasePublisher',{key:site.siteKey,attrs:{"siteKey":site.siteKey,"origin":site.initialDomainWithProtocol}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }